<template>
  <div>
    <v-container fluid>
      <v-row dense>
        <v-col align="center"><bar-chart :chart-data="endpointCallCountChartData" :options="defaultChartOptions"/></v-col>
        <v-col align="center"><bar-chart :chart-data="endpointLatencyCountChartData" :options="defaultChartOptions"/></v-col>
        <v-col align="center"><bar-chart :chart-data="failureCountChartData" :options="defaultChartOptions"/></v-col>
        <v-col align="center">Endpoints Usage Details Table
          <v-text-field class="ma-auto" v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details/>
          <br>
          <v-data-table dense :headers="headers" :items="statistics" :search="search" :items-per-page=10 />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {eSailServerPublic} from "@/plugins/axios";
import _ from "lodash";
import BarChart from "@/components/charts/BarChart";
import 'chartjs-plugin-colorschemes';

export default {
  name: "ServerStatistics",
  components: {BarChart},
  data: () => ({
    statistics: [],
    search: '',
    headers: [
      { text: 'Endpoint', value: 'path' },
      { text: 'Method', value: 'method' },
      { text: 'Count', value: 'totalMetrics.count' },
      { text: 'Avg Latency (ms)', value: 'totalMetrics.avgLatency' },
      { text: 'Min Latency (ms)', value: 'totalMetrics.minLatency' },
      { text: 'Max Latency (ms)', value: 'totalMetrics.maxLatency' }
    ],
    endpointCallCountChartData: {},
    endpointLatencyCountChartData: {},
    failureCountChartData: {},
    defaultChartOptions: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        colorschemes: {
          scheme: 'tableau.Tableau10'
        }
      }
    }
  }),
  mounted() {
    eSailServerPublic.get('admin/api-metrics', { headers: { Authorization: `Bearer ` + this.$auth.token() }})
        .then(response => {
          this.statistics = response.data

          const endpointCallsGreaterMinThreshold = _.filter(this.statistics, item => { return item.totalMetrics.count > 20 })
          this.endpointCallCountChartData = {
            labels: _.map(endpointCallsGreaterMinThreshold, 'path'),
            datasets: [{
              label: "Request Count",
              data: _.map(endpointCallsGreaterMinThreshold, 'totalMetrics.count')
            }]
          }

          this.endpointLatencyCountChartData = {
            labels: _.map(endpointCallsGreaterMinThreshold, 'path'),
            datasets: [{
              label: "Average Latency",
              data: _.map(endpointCallsGreaterMinThreshold, 'totalMetrics.avgLatency')
            },{
              label: "Min Latency",
              data: _.map(endpointCallsGreaterMinThreshold, 'totalMetrics.minLatency')
            },{
              label: "Max Latency",
              data: _.map(endpointCallsGreaterMinThreshold, 'totalMetrics.maxLatency')
            }]
          }

          let failureResponses = []
          _.each(endpointCallsGreaterMinThreshold, item => {
            const failureResponseMetric = _.pickBy(item.responseMetrics, function (value, key) {
              return (key >= 400);
            })
            //workaround to transform dynamic HTTP code json key into easier parseable
            const jsonKeyForFailure = Object.keys(failureResponseMetric)[0]
            if (jsonKeyForFailure !== undefined) {
              let failureResponseObj = {}
              failureResponseObj.path = item.path
              failureResponseObj.method = item.method
              failureResponseObj.metrics = failureResponseMetric[jsonKeyForFailure]
              failureResponses.push(failureResponseObj)
            }
          })
          failureResponses = _.orderBy(failureResponses, 'metrics.counts.count', 'desc')
          this.failureCountChartData = {
            labels: _.map(failureResponses, item => { return item.metrics.code + ": " + item.method + " " + item.path }),
            datasets: [{
              label: "Failure Count",
              data: _.map(failureResponses, 'metrics.counts.count')
            }]
          }

        })
  }
}
</script>

<style scoped>

</style>